<template>
  <window title="Geochart">
    <vue-chart chart-type="GeoChart" :columns="columns" :rows="rows" :options="options"></vue-chart>
  </window>
</template>

<script>
export default {
  data() {
    return {
      columns: [{
        type: 'string',
        label: 'Country',
      }, {
        type: 'number',
        label: 'Popularity',
      }],
      rows: [
        ['Germany', 200],
        ['United States', 300],
        ['Brazil', 400],
        ['Canada', 600],
        ['France', 201],
      ],
      options: {
        title: 'Popularity by Countries',
        width: '100%',
        height: 'auto',
      },
    };
  },
};
</script>
